import { render, staticRenderFns } from "./TabContentsOnSite.vue?vue&type=template&id=c622c026"
import script from "./TabContentsOnSite.vue?vue&type=script&lang=js"
export * from "./TabContentsOnSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports